import React, { useState, useEffect } from "react";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import RouteConfig from "../../common/routeConfig";
import { Consume } from "../../Context/Consumer";
import {
  isLoggedIn,
  getData,
  hasTeam,
  getLoginCookie,
  deleteCookie,
  showLoader,
  getTrans,
  googleAnalyticsEventTracking,
  redirectToPredictor,
} from "../../common";
import {
  LoginContext,
  TransContext,
  ConstraintsContext,
  LeaguesContext,
} from "../../Context";
import config from "../../common/config";
import SubMenu from "./SubMenu";
import OutsideNotifier from "../OutsideNotifier";
import { clearAllBodyScrollLocks } from "body-scroll-lock";

const MainMenu = (props) => {
  let location = useLocation();
  let cookie = getLoginCookie();
  let history = useHistory();
  let loginData = props.loginData;
  let trans = props.TransData.data;
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [userDrpDwn, setUserDrpDwn] = useState(false);
  const [userProfileSelect, setUserProfileSelect] = useState(false);
  const [logoutSelect, setLogoutSelect] = useState(false);
  const [langDrpDwn, setLangDrpDwn] = useState(false);
  const [updatemenuonhover, setUpdatemenuonhover] = useState(false);
  const [update, setUpdate] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    window[config.namespaceKey].currentScreen
  );

  useEffect(() => {
    if (cookie && cookie.IsRegistered) {
      if (props.loginData.userProfile === null) {
        props.loginData.getUserProfileData(
          { language: config.language },
          () => {}
        );
      }
      let data = props.loginData.userProfile;
    }
  }, []);

  /* useEffect(() => {
    clearAllBodyScrollLocks();
  }, []); */

  useEffect(() => {
    setCurrentPage(location.pathname);
    setShowMobileMenu(false);
  }, [currentPage, location.pathname]);

  let userDrpDwnHandler = (value) => {
    if (value != undefined) {
      setUserDrpDwn(false);
    } else {
      setUserDrpDwn(!userDrpDwn);
    }
  };

  let langDrpDwnHandler = (value) => {
    if (value != undefined) {
      setLangDrpDwn(false);
    } else {
      setLangDrpDwn(!langDrpDwn);
    }
  };

  let mobileMenuHandler = (value) => {
    if (value != undefined) {
      setShowMobileMenu(false);
    } else {
      setShowMobileMenu(!showMobileMenu);
    }
  };

  let onLogoutHandler = () => {
    loginData.makeLogoutCall({ isReload: true });
  };

  let profilePageHandler = () => {
    const { action, category, label } = config.trackclickEvents.profile;
    googleAnalyticsEventTracking(action, category, label);
    setLogoutSelect(false);
    setUserProfileSelect(!userProfileSelect);
    history.push(config.BASE_DOMAIN_LANG + "profile");
    userDrpDwnHandler(false);
  };

  let menuList = () => {
    let menus = RouteConfig.filter((route) => {
      if (route.isTabMenu) {
        return true;
      } else {
        return false;
      }
    });
    let tabMenus = [];

    if (cookie && hasTeam()) {
      tabMenus = menus.filter((menu) => {
        let show = false;
        if (menu.isAuthRequired && menu.isTabMenu && !menu.isCommonPage) {
          menu.clickHandler = {
            onClick: (e) => {
              setTimeout(() => {
                setUpdate(true);
              }, 500);
              if (!e.ctrlKey) {
                e.preventDefault();
                const { action, category, label } =
                  config.trackclickEvents[menu.name.split("-").join("")];
                googleAnalyticsEventTracking(action, category, label);
                if (window[config.namespaceKey].currentScreen != menu.path) {
                  history.push(menu.pathroute ? menu.pathroute : menu.path);
                }
              }
            },
          };
          menu.url = menu.pathroute ? menu.pathroute : menu.path;
          show = true;
        } else if (menu.isCommonPage) {
          menu.clickHandler = {
            onClick: (e) => {
              setTimeout(() => {
                setUpdate(true);
              }, 100);
              if (!e.ctrlKey) {
                e.preventDefault();
                const { action, category, label } =
                  config.trackclickEvents[menu.name.split("-").join("")];
                googleAnalyticsEventTracking(action, category, label);
                if (window[config.namespaceKey].currentScreen != menu.path) {
                  history.push(menu.pathroute ? menu.pathroute : menu.path);
                }
              }
            },
          };
          menu.url = menu.pathroute ? menu.pathroute : menu.path;
          show = true;
        }
        return show ? menu : false;
      });
    } else if ((cookie && !hasTeam()) || !cookie) {
      tabMenus = menus.filter((menu) => {
        let show = false;
        if (!menu.isAuthRequired && menu.isTabMenu && !menu.isCommonPage) {
          show = true;
          menu.clickHandler = {
            onClick: (e) => {
              setTimeout(() => {
                setUpdate(true);
              }, 100);
              if (!e.ctrlKey) {
                e.preventDefault();
                const { action, category, label } =
                  config.trackclickEvents[menu.name.split("-").join("")];
                googleAnalyticsEventTracking(action, category, label);
                if (window[config.namespaceKey].currentScreen != menu.path) {
                  history.push(menu.pathroute ? menu.pathroute : menu.path);
                }
              }
            },
          };
          menu.url = menu.pathroute ? menu.pathroute : menu.path;
        } else if (menu.isCommonPage) {
          menu.clickHandler = {
            onClick: (e) => {
              setTimeout(() => {
                setUpdate(true);
              }, 100);
              if (!e.ctrlKey) {
                e.preventDefault();
                const { action, category, label } =
                  config.trackclickEvents[menu.name.split("-").join("")];
                googleAnalyticsEventTracking(action, category, label);
                if (window[config.namespaceKey].currentScreen != menu.path) {
                  history.push(menu.pathroute ? menu.pathroute : menu.path);
                }
              }
            },
          };
          menu.url = menu.pathroute ? menu.pathroute : menu.path;
          show = true;
        }
        return show ? menu : false;
      });
    }

    let markup = tabMenus.map((menu, index) => {
      /* console.log("the path is", menu.path);
			console.log("the screen is", location.pathname); */
      let activeClass = false;
      if (menu.path == window.currentPage) {
        activeClass = true;
      } else {
        if (
          menu.group == "create-team" ||
          menu.group == "manage-team" ||
          menu.group == "league"
        ) {
          if (menu.groupRoutes.indexOf(window.currentPage) > -1) {
            activeClass = true;
          }
        } else {
          activeClass = false;
        }
      }
      return (
        <li
          key={index}
          {...menu.clickHandler}
          onMouseLeave={() => {
            setUpdatemenuonhover(!updatemenuonhover);
          }}
        >
          <a className={activeClass ? "active" : ""} href={menu.url}>
            <span>
              {getTrans(trans, "menu_" + menu.name, menu.fallbackName)}
            </span>
          </a>
        </li>
      );
    });

    return <ul>{markup}</ul>;
  };

  const redirectToPredictorGame = () => {
    const { action, category, label } = config.trackclickEvents.predictor;
    googleAnalyticsEventTracking(action, category, label);
    redirectToPredictor();
  };

  let predictorCtaMakrup = () => {
    return (
      <div className="si-mainMenu__cta">
        <div className="si-mainMenu__cta-lbl">
          <span>
            {getTrans(
              trans,
              "most_awaited_predictor_game",
              "Most awaited predictor game is here!"
            )}
          </span>
        </div>
        <div
          className="si-btn si-btn__complementary"
          onClick={() => redirectToPredictorGame()}
        >
          {/* <!-- si-disabled --> */}
          <span>
            {getTrans(
              trans,
              "menu_predictor_btn_coming_soon",
              "Play Match Predictor"
            )}
            {/* {getTrans(trans, "play_match_predictor", "Play Match Predictor")} */}
          </span>
          <i className="uae-right-arrow"></i>
        </div>
      </div>
    );
  };

  let changeLangHandler = (lang) => {
    let url = window.location.href;
    let currentLang = window.location.pathname.split("/")[2];
    langDrpDwnHandler(false);
    const { action, category, label } = config.trackclickEvents[lang];
    googleAnalyticsEventTracking(action, category, label);
    if (currentLang !== lang) {
      url = url.replace(currentLang, lang);
      window.location.href = url;
    }
  };

  let languageDropDown = () => {
    return (
      <div className="si-mainMenu__dropDown">
        <OutsideNotifier handler={() => langDrpDwnHandler(false)}>
          <div
            className={`si-drpDwn si-drpDwn--whiteLine ${
              langDrpDwn ? "si-active" : ""
            }`}
          >
            <div
              className="si-drpDwn__value si-picked"
              onClick={() => langDrpDwnHandler()}
            >
              <span>
                {getTrans(
                  trans,
                  config.LangNameArr[window.location.pathname.split("/")[2]]
                )}
              </span>
            </div>
            <div className="si-drpDwn__list">
              <ul>
                {config.langArr.map((lang) => {
                  return (
                    <li
                      onClick={() => {
                        changeLangHandler(lang);
                      }}
                      key={lang}
                      className={
                        window.location.pathname.split("/")[2] === lang
                          ? "si-active"
                          : ""
                      }
                    >
                      {getTrans(trans, config.LangNameArr[lang])}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    );
  };

  let menuLoginBtn = () => {
    let onLogin = () => {
      // window.location.href = config.LoginUrl;
      mobileMenuHandler(false);
      loginData.setObjShowHideLogin({
        screenMode: config.loginScreenMode.main,
      });
      loginData.setIsShowLoginPopup(true);
    };
    return (
      <div className="si-mainMenu__login">
        <span onClick={() => onLogin()}>
          <i className="uae-user"></i>{" "}
          {getTrans(trans, "login_register", "Login / Register")}
        </span>
      </div>
    );
  };

  let subMenu = RouteConfig.filter((menu) => {
    if (
      menu.isSubMenu &&
      window.location.pathname.indexOf(`/${menu.name}`) > -1
    ) {
      if (menu.name === "create-team") {
        menu.pageName = getTrans(trans, "create_your_team", "Create Your Team");
      } else if (menu.name === "view-others-team") {
        menu.pageName = props.LeaguesData.oUname;
      } else {
        menu.pageName = getTrans(trans, "menu_" + menu.name, menu.fallbackName);
      }

      return menu;
    }
  });

  let userProfileDesktop = () => {
    return (
      <div className="si-mainMenu__dropDown">
        <OutsideNotifier handler={() => userDrpDwnHandler(false)}>
          <div
            className={`si-drpDwn si-drpDwn--whiteLine ${
              userDrpDwn ? "si-active" : ""
            }`}
          >
            <div
              className="si-drpDwn__value si-picked"
              onClick={() => userDrpDwnHandler()}
            >
              <span>{`${props.loginData.userProfile.userName}`}</span>
            </div>
            <div className="si-drpDwn__list">
              <ul>
                <li
                  className={userProfileSelect ? "si-acitve" : ""}
                  onClick={() => profilePageHandler()}
                >
                  {getTrans(trans, "menu_profile", "My Profile")}
                </li>
                <li
                  className={logoutSelect ? "si-acitve" : ""}
                  onClick={() => onLogoutHandler()}
                >
                  {getTrans(trans, "logout", "Logout")}
                </li>
              </ul>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    );
  };

  let userProfileMobile = () => {
    return (
      <div className="si-hamburger__profile">
        <div className="si-profile">
          <div className="si-profileName-first">
            <span>{getTrans(trans, "username", "Username")}</span>
          </div>
          <div className="si-profileName-last">
            <span>{props.loginData.userProfile.userName}</span>
          </div>
        </div>
        <div className="si-profile__foot">
          <div className="si-profile__club">
            <div className="si-profile__club-lbl">
              <span>{getTrans(trans, "fav_club", "Fav. Club")}: </span>
            </div>
            <div className="si-fixtures__team">
              <div
                className="si-fixtures__team-logo"
                style={{
                  backgroundImage: `url(${config.IMG_BASE}clubs/${props.loginData.userProfile.favTeamID}.png?v=${props.ConstraintsData?.data?.PlayerJerseyTeamVersion})`,
                }}
              ></div>
              <div className="si-fixtures__team-name">
                <span>{props.loginData.userProfile.favTeamName}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="si-profile__btm">
          <div
            className="si-profile__link"
            onClick={() => {
              profilePageHandler();
            }}
          >
            <span>
              {getTrans(trans, "view_full_profile", "View Full Profile")}
            </span>
          </div>
          <div
            className="si-profile__link"
            onClick={() => {
              onLogoutHandler();
            }}
          >
            <span>{getTrans(trans, "logout", "Logout")}</span>
          </div>
        </div>
      </div>
    );
  };

  let menuOutSideHandler = {
    handler: (e) => {
      e.stopPropagation();
      mobileMenuHandler(false);
    },
  };

  return (
    <React.Fragment>
      {window.screen.width >= 991 ? (
        <div className="si-main__container--fluid si-mainMenu__wrap si-bg--black05">
          <div className="si-main__container">
            <div className="si-mainMenu__box">
              <a
                href={config.BASE_DOMAIN_LANG + "home"}
                className="si-mainMenu__brand"
              >
                <img
                  src={`${config.IMG_BASE}uae-main-logo.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    trans,
                    "uae_pro_league_fantasy_alt",
                    "UAE Pro League Fantasy 2021"
                  )}
                  title={getTrans(
                    trans,
                    "uae_pro_league_fantasy_title",
                    "UAE Pro League Fantasy 2021"
                  )}
                />
              </a>

              <div className="si-mainMenu__rgt">
                {predictorCtaMakrup()}
                {languageDropDown()}
                {!cookie
                  ? menuLoginBtn()
                  : props.loginData.userProfile
                  ? userProfileDesktop()
                  : null}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {subMenu[subMenu.length - 1] === undefined ||
      !subMenu[subMenu.length - 1].isSubMenu ? (
        window.screen.width < 991 ? (
          <OutsideNotifier {...menuOutSideHandler}>
            <div className="si-main__container--fluid si-bg--black05">
              <div className="si-main__container">
                <div className="si-header">
                  <div className="si-header__menu">
                    <i
                      className="uae-menu"
                      onClick={() => setShowMobileMenu(true)}
                    ></i>
                  </div>
                  <div className="si-header__title">
                    <span>
                      {getTrans(
                        trans,
                        "uae_pro_league_fantasy_alt",
                        "UAE Pro League Fantasy 2021"
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`si-hamburger__wrap si-fade ${
                showMobileMenu ? "in" : "out"
              }`}
            >
              <div className="si-hamburger__box">
                <div className="si-hamburger__close">
                  <i
                    className="uae-close"
                    onClick={() => setShowMobileMenu(false)}
                  ></i>
                </div>
                {languageDropDown()}
                {!cookie ? (
                  <div className="si-hamburger__profile">
                    <div className="si-profile__intro">
                      <span>{getTrans(trans, "profile_intro", "text")}</span>
                    </div>
                    {menuLoginBtn()}
                  </div>
                ) : props.loginData.userProfile ? (
                  userProfileMobile()
                ) : null}
                <div className="si-hamburger__nav">
                  <div className="si-hamburger__nav-title">
                    <span>
                      {getTrans(trans, "fantasy_football", "FANTASY FOOTBALL")}
                    </span>
                  </div>
                  {menuList()}
                </div>
                {predictorCtaMakrup()}
              </div>
            </div>
          </OutsideNotifier>
        ) : (
          <div className="si-main__container--fluid si-menu__wrap si-bg--black05">
            <div className="si-main__container">
              <nav className="si-menu si-menu__list">{menuList()}</nav>
            </div>
          </div>
        )
      ) : (
        <SubMenu pageName={subMenu[subMenu.length - 1].pageName} />
      )}
    </React.Fragment>
  );
};

export default withRouter(
  Consume(MainMenu, [
    LoginContext,
    ConstraintsContext,
    TransContext,
    LeaguesContext,
  ])
);
